import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { LIGHT_GREY } from "styles/oneOffColor";

import { TemplateContentType } from "features/Influencer/ContactList/schema";
import { FormAnswer } from "features/Influencer/Templates/TemplatesTable/CreateTemplate/schema";

const styles = {
  chipAnnotation: {
    backgroundColor: "#f1f3f3",
    borderRadius: 6,
    color: "green.main",
    width: "max-content",
    px: 2,
    py: 1,
    display: "block",
    margin: "auto",
    mb: 2,
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 2,
      backgroundColor: "white",
    },
  },
};

interface Props {
  handleSubmit: () => void;
  handleBack: () => void;
  form: FormAnswer;
  setForm: React.Dispatch<React.SetStateAction<FormAnswer>>;
}

const TemplatePromptForm = ({
  handleSubmit,
  handleBack,
  form,
  setForm,
}: Props) => {
  const isValid = form.userPrompt && form.userPrompt.trim().length > 0;

  const placeholder =
    form?.templateContentType === TemplateContentType.OUTREACH
      ? "Create a pitch template for pet brands. Mention I have two cats and have worked with PetSmart..."
      : "Create a follow-up template for pet brands. Emphasize that I can help increase customer engagement...";

  return (
    <Grid>
      <Box sx={styles.chipAnnotation}>💭 Let's answer a few questions</Box>
      <Typography
        textAlign="center"
        variant="h3"
        gutterBottom
        sx={{ textAlign: "center", fontSize: { xs: 20, md: 28 } }}
      >
        What would you like us to write?
      </Typography>

      <Grid container justifyContent="center">
        <Grid item xs={12} sx={{ width: { xs: "auto", md: 600 }, mx: "auto" }}>
          <TextField
            fullWidth
            multiline
            rows={4}
            placeholder={placeholder}
            value={form.userPrompt || ""}
            onChange={(e) =>
              setForm((prev) => ({ ...prev, userPrompt: e.target.value }))
            }
            sx={styles.textField}
          />
          <Typography sx={{ color: grey[500], fontSize: 12, mt: 1 }}>
            For best results, be specific.
          </Typography>
        </Grid>
      </Grid>

      <Grid container justifyContent={"center"} gap={1} sx={{ mt: 4 }}>
        <Button
          sx={{ px: 3, py: 1, backgroundColor: LIGHT_GREY }}
          onClick={handleBack}
          disableElevation
        >
          <Box
            component="i"
            className="fa-regular fa-circle-arrow-left"
            sx={{ mr: 1 }}
          />{" "}
          Back
        </Button>

        <Button
          sx={{ minWidth: 200, py: 1 }}
          variant="contained"
          onClick={handleSubmit}
          disableElevation
          disabled={!isValid}
        >
          Next
        </Button>
      </Grid>
    </Grid>
  );
};

export default TemplatePromptForm;
